/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AbortMultipartRequest } from '../model/abortMultipartRequest';
import { ClassificationBatchDTO } from '../model/classificationBatchDTO';
import { CompleteMultipartRequest } from '../model/completeMultipartRequest';
import { FileDashboardSummary } from '../model/fileDashboardSummary';
import { FileDeletionBatchDTO } from '../model/fileDeletionBatchDTO';
import { FileMetadataDTO } from '../model/fileMetadataDTO';
import { FileUploadStringTransfer } from '../model/fileUploadStringTransfer';
import { MultipartInitResponse } from '../model/multipartInitResponse';
import { ProjectFile } from '../model/projectFile';
import { ProjectFileTableDTO } from '../model/projectFileTableDTO';
import { StringTransfer } from '../model/stringTransfer';
import { TrashEntryDTO } from '../model/trashEntryDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ProjectFileControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public abortMultipartUpload(body: AbortMultipartRequest, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public abortMultipartUpload(body: AbortMultipartRequest, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public abortMultipartUpload(body: AbortMultipartRequest, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public abortMultipartUpload(body: AbortMultipartRequest, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling abortMultipartUpload.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling abortMultipartUpload.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling abortMultipartUpload.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}/multipart/abort`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public classify(projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public classify(projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public classify(projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public classify(projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling classify.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling classify.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProjectFile>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}/classify`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public completeMultipartUpload(body: CompleteMultipartRequest, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public completeMultipartUpload(body: CompleteMultipartRequest, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public completeMultipartUpload(body: CompleteMultipartRequest, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public completeMultipartUpload(body: CompleteMultipartRequest, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling completeMultipartUpload.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling completeMultipartUpload.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling completeMultipartUpload.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProjectFile>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}/multipart/complete`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param filename 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public copyProjectFile(body: string, projectId: number, id: string, filename?: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public copyProjectFile(body: string, projectId: number, id: string, filename?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public copyProjectFile(body: string, projectId: number, id: string, filename?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public copyProjectFile(body: string, projectId: number, id: string, filename?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling copyProjectFile.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling copyProjectFile.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling copyProjectFile.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (filename !== undefined && filename !== null) {
            queryParameters = queryParameters.set('filename', <any>filename);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProjectFile>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}/copy`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createClassificationBatch(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<ClassificationBatchDTO>;
    public createClassificationBatch(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClassificationBatchDTO>>;
    public createClassificationBatch(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClassificationBatchDTO>>;
    public createClassificationBatch(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createClassificationBatch.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createClassificationBatch.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ClassificationBatchDTO>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/classification-batches`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param name 
     * @param projectId 
     * @param parentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createCoordinationModel(body: Array<string>, name: string, projectId: number, parentId?: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public createCoordinationModel(body: Array<string>, name: string, projectId: number, parentId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public createCoordinationModel(body: Array<string>, name: string, projectId: number, parentId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public createCoordinationModel(body: Array<string>, name: string, projectId: number, parentId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createCoordinationModel.');
        }

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling createCoordinationModel.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createCoordinationModel.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (parentId !== undefined && parentId !== null) {
            queryParameters = queryParameters.set('parentId', <any>parentId);
        }
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProjectFile>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/newCoordinationModel`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createDeletionBatch(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<FileDeletionBatchDTO>;
    public createDeletionBatch(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileDeletionBatchDTO>>;
    public createDeletionBatch(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileDeletionBatchDTO>>;
    public createDeletionBatch(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createDeletionBatch.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createDeletionBatch.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<FileDeletionBatchDTO>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/deletion-batches`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param parentId 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFolder(body: ProjectFile, parentId: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public createFolder(body: ProjectFile, parentId: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public createFolder(body: ProjectFile, parentId: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public createFolder(body: ProjectFile, parentId: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createFolder.');
        }

        if (parentId === null || parentId === undefined) {
            throw new Error('Required parameter parentId was null or undefined when calling createFolder.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createFolder.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (parentId !== undefined && parentId !== null) {
            queryParameters = queryParameters.set('parentId', <any>parentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProjectFile>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/newFolder`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param parentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createFolderStructure(body: Array<string>, projectId: number, parentId?: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public createFolderStructure(body: Array<string>, projectId: number, parentId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public createFolderStructure(body: Array<string>, projectId: number, parentId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public createFolderStructure(body: Array<string>, projectId: number, parentId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createFolderStructure.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createFolderStructure.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (parentId !== undefined && parentId !== null) {
            queryParameters = queryParameters.set('parentId', <any>parentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{ [key: string]: string; }>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/createFolderStructure`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteProjectFile(projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public deleteProjectFile(projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public deleteProjectFile(projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public deleteProjectFile(projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteProjectFile.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteProjectFile.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProjectFile>('delete',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSelectedProjectFiles(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectFile>>;
    public deleteSelectedProjectFiles(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectFile>>>;
    public deleteSelectedProjectFiles(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectFile>>>;
    public deleteSelectedProjectFiles(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling deleteSelectedProjectFiles.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteSelectedProjectFiles.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ProjectFile>>('delete',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/deleteSelected`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param zipName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadZip(body: Array<ProjectFile>, projectId: number, zipName: string, observe?: 'body', reportProgress?: boolean): Observable<StringTransfer>;
    public downloadZip(body: Array<ProjectFile>, projectId: number, zipName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StringTransfer>>;
    public downloadZip(body: Array<ProjectFile>, projectId: number, zipName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StringTransfer>>;
    public downloadZip(body: Array<ProjectFile>, projectId: number, zipName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling downloadZip.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling downloadZip.');
        }

        if (zipName === null || zipName === undefined) {
            throw new Error('Required parameter zipName was null or undefined when calling downloadZip.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (zipName !== undefined && zipName !== null) {
            queryParameters = queryParameters.set('zipName', <any>zipName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<StringTransfer>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/downloadZip`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveClassificationBatches(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ClassificationBatchDTO>>;
    public getActiveClassificationBatches(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ClassificationBatchDTO>>>;
    public getActiveClassificationBatches(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ClassificationBatchDTO>>>;
    public getActiveClassificationBatches(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getActiveClassificationBatches.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ClassificationBatchDTO>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/classification-batches/active`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveDeletionBatches(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<FileDeletionBatchDTO>>;
    public getActiveDeletionBatches(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FileDeletionBatchDTO>>>;
    public getActiveDeletionBatches(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FileDeletionBatchDTO>>>;
    public getActiveDeletionBatches(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getActiveDeletionBatches.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<FileDeletionBatchDTO>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/deletion-batches/active`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDashboardSummary(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<FileDashboardSummary>;
    public getDashboardSummary(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileDashboardSummary>>;
    public getDashboardSummary(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileDashboardSummary>>;
    public getDashboardSummary(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getDashboardSummary.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<FileDashboardSummary>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/dashboard-summary`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFile(projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public getFile(projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public getFile(projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public getFile(projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getFile.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getFile.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProjectFile>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param fileType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFiles(projectId: number, fileType?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectFile>>;
    public getFiles(projectId: number, fileType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectFile>>>;
    public getFiles(projectId: number, fileType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectFile>>>;
    public getFiles(projectId: number, fileType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getFiles.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (fileType !== undefined && fileType !== null) {
            queryParameters = queryParameters.set('fileType', <any>fileType);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProjectFile>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFilesByIds(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectFile>>;
    public getFilesByIds(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectFile>>>;
    public getFilesByIds(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectFile>>>;
    public getFilesByIds(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling getFilesByIds.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getFilesByIds.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<ProjectFile>>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/by-ids`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFilesForTable(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ProjectFileTableDTO>>;
    public getFilesForTable(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProjectFileTableDTO>>>;
    public getFilesForTable(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProjectFileTableDTO>>>;
    public getFilesForTable(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getFilesForTable.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProjectFileTableDTO>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/table`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTrash(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<TrashEntryDTO>>;
    public getTrash(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TrashEntryDTO>>>;
    public getTrash(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TrashEntryDTO>>>;
    public getTrash(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getTrash.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<TrashEntryDTO>>('get',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/trash`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param orgfilename 
     * @param filesize 
     * @param parentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public initiateMultipartUpload(projectId: number, orgfilename: string, filesize: number, parentId?: string, observe?: 'body', reportProgress?: boolean): Observable<MultipartInitResponse>;
    public initiateMultipartUpload(projectId: number, orgfilename: string, filesize: number, parentId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MultipartInitResponse>>;
    public initiateMultipartUpload(projectId: number, orgfilename: string, filesize: number, parentId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MultipartInitResponse>>;
    public initiateMultipartUpload(projectId: number, orgfilename: string, filesize: number, parentId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling initiateMultipartUpload.');
        }

        if (orgfilename === null || orgfilename === undefined) {
            throw new Error('Required parameter orgfilename was null or undefined when calling initiateMultipartUpload.');
        }

        if (filesize === null || filesize === undefined) {
            throw new Error('Required parameter filesize was null or undefined when calling initiateMultipartUpload.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (parentId !== undefined && parentId !== null) {
            queryParameters = queryParameters.set('parentId', <any>parentId);
        }
        if (orgfilename !== undefined && orgfilename !== null) {
            queryParameters = queryParameters.set('orgfilename', <any>orgfilename);
        }
        if (filesize !== undefined && filesize !== null) {
            queryParameters = queryParameters.set('filesize', <any>filesize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MultipartInitResponse>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/multipart/initiate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public markFilesUploaded(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public markFilesUploaded(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public markFilesUploaded(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public markFilesUploaded(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling markFilesUploaded.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling markFilesUploaded.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/uploaded`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public markUploadsAborted(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public markUploadsAborted(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public markUploadsAborted(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public markUploadsAborted(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling markUploadsAborted.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling markUploadsAborted.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/uploads/aborted`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveFilesToTrash(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public moveFilesToTrash(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public moveFilesToTrash(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public moveFilesToTrash(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling moveFilesToTrash.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling moveFilesToTrash.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/trash`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param newParentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveMultipleProjectFiles(body: Array<string>, projectId: number, newParentId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public moveMultipleProjectFiles(body: Array<string>, projectId: number, newParentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public moveMultipleProjectFiles(body: Array<string>, projectId: number, newParentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public moveMultipleProjectFiles(body: Array<string>, projectId: number, newParentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling moveMultipleProjectFiles.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling moveMultipleProjectFiles.');
        }

        if (newParentId === null || newParentId === undefined) {
            throw new Error('Required parameter newParentId was null or undefined when calling moveMultipleProjectFiles.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (newParentId !== undefined && newParentId !== null) {
            queryParameters = queryParameters.set('newParentId', <any>newParentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/moveMultiple`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveProjectFile(body: string, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public moveProjectFile(body: string, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public moveProjectFile(body: string, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public moveProjectFile(body: string, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling moveProjectFile.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling moveProjectFile.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling moveProjectFile.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}/move`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purgeFromTrash(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public purgeFromTrash(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public purgeFromTrash(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public purgeFromTrash(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling purgeFromTrash.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling purgeFromTrash.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/trash/purge`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public renameProjectFile(body: string, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public renameProjectFile(body: string, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public renameProjectFile(body: string, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public renameProjectFile(body: string, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling renameProjectFile.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling renameProjectFile.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling renameProjectFile.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public restoreFromTrash(body: Array<string>, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public restoreFromTrash(body: Array<string>, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public restoreFromTrash(body: Array<string>, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public restoreFromTrash(body: Array<string>, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling restoreFromTrash.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restoreFromTrash.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/trash/restore`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCoordinationModel(body: Array<string>, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public updateCoordinationModel(body: Array<string>, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public updateCoordinationModel(body: Array<string>, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public updateCoordinationModel(body: Array<string>, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateCoordinationModel.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling updateCoordinationModel.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateCoordinationModel.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProjectFile>('put',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}/coordinationModel`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateFileStatus(body: string, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public updateFileStatus(body: string, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public updateFileStatus(body: string, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public updateFileStatus(body: string, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateFileStatus.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling updateFileStatus.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateFileStatus.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProjectFile>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}/updateStatus`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateModelTag(projectId: number, id: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<ProjectFile>;
    public updateModelTag(projectId: number, id: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProjectFile>>;
    public updateModelTag(projectId: number, id: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProjectFile>>;
    public updateModelTag(projectId: number, id: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling updateModelTag.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateModelTag.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProjectFile>('put',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/${encodeURIComponent(String(id))}/modelTag`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param orgfilename 
     * @param filesize 
     * @param parentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upload(projectId: number, orgfilename: string, filesize: number, parentId?: string, observe?: 'body', reportProgress?: boolean): Observable<FileUploadStringTransfer>;
    public upload(projectId: number, orgfilename: string, filesize: number, parentId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileUploadStringTransfer>>;
    public upload(projectId: number, orgfilename: string, filesize: number, parentId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileUploadStringTransfer>>;
    public upload(projectId: number, orgfilename: string, filesize: number, parentId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling upload.');
        }

        if (orgfilename === null || orgfilename === undefined) {
            throw new Error('Required parameter orgfilename was null or undefined when calling upload.');
        }

        if (filesize === null || filesize === undefined) {
            throw new Error('Required parameter filesize was null or undefined when calling upload.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (parentId !== undefined && parentId !== null) {
            queryParameters = queryParameters.set('parentId', <any>parentId);
        }
        if (orgfilename !== undefined && orgfilename !== null) {
            queryParameters = queryParameters.set('orgfilename', <any>orgfilename);
        }
        if (filesize !== undefined && filesize !== null) {
            queryParameters = queryParameters.set('filesize', <any>filesize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<FileUploadStringTransfer>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/upload`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param parentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadBatch(body: Array<FileMetadataDTO>, projectId: number, parentId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FileUploadStringTransfer>>;
    public uploadBatch(body: Array<FileMetadataDTO>, projectId: number, parentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FileUploadStringTransfer>>>;
    public uploadBatch(body: Array<FileMetadataDTO>, projectId: number, parentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FileUploadStringTransfer>>>;
    public uploadBatch(body: Array<FileMetadataDTO>, projectId: number, parentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling uploadBatch.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling uploadBatch.');
        }

        if (parentId === null || parentId === undefined) {
            throw new Error('Required parameter parentId was null or undefined when calling uploadBatch.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (parentId !== undefined && parentId !== null) {
            queryParameters = queryParameters.set('parentId', <any>parentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<FileUploadStringTransfer>>('post',`${this.basePath}/projects/${encodeURIComponent(String(projectId))}/files/uploadBatch`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
